import { UsersApi } from "@/api/users";
import { User } from "@/types";
import { QueryKey } from "@/utils";
import { useQuery } from "@tanstack/react-query";
import { useNotify, useRedirect } from "react-admin";

export const useGetUser = (id: User["id"]) => {
  const redirect = useRedirect();
  const notify = useNotify();

  const { data, isPending, isError, error } = useQuery({
    queryKey: [QueryKey.USER, id],
    queryFn: () => UsersApi.getUser({ userId: id }),
    enabled: !!id,
  });

  if (isError) {
    notify(error, { type: "error" });
    redirect("list");
  }

  return { user: data!, isUserLoading: isPending };
};
